export const QUESTION = '/question/'
export const QUESTION_ALL = `${QUESTION}all` as const
export const QUESTION_TYPES = `${QUESTION}types` as const
export const QUESTION_TYPES_COUNTS = `${QUESTION}types_counts` as const
export const QUESTION_IMPORT = `${QUESTION}import` as const
